const AboutData = () => {
  return (
    <div className="about-data-container">
      <h1>Numbers Speak For Themselves</h1>
      <div className="about-data-rows">
        <div className="data-row-1">
          <p>5000+ </p>
          <h2>Curated Products</h2>
        </div>
        <div className="data-row-2">
          <p>800+ </p>
          <h2>Curated Products</h2>
        </div>
        <div className="data-row-3">
          <p>40+ </p>
          <h2>Product Categories</h2>
        </div>
      </div>
    </div>
  );
};

export default AboutData;
